/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './AppsRpc';
import * as Queries from './AppsRpc.dfc.new';
import type { AdditionalContextArgs } from './AppsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetAllQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetAllResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getAll', References.GetAllResponseType>
        : References.GetAllResponseType)
    | undefined;
};

export function useGetAllQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAllResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAllQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_ALL_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAll: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetAllQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetAllQueryReturn<T>;
}

type UseGetAllLazyQueryReturn<T extends boolean> = LazyQueryResultTupleOverride<
  Record<'result', References.GetAllResponseType>,
  {},
  T extends true
    ? Record<'getAll', References.GetAllResponseType>
    : References.GetAllResponseType
>;

export function useGetAllLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAllResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAllLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_ALL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAll: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAllLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAllLazyQueryReturn<T>;
}

type UseGetAllSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<Record<'result', References.GetAllResponseType>>,
  'data'
> & {
  data: T extends true
    ? Record<'getAll', References.GetAllResponseType>
    : References.GetAllResponseType;
};

export function useGetAllSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAllResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAllSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_ALL_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAll: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAllSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAllSuspenseQueryReturn<T>;
}

type UseGetAppQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppResponseType>,
    References.GetAppRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getApp', References.GetAppResponseType>
        : References.GetAppResponseType)
    | undefined;
};

export function useGetAppQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppResponseType>,
    References.GetAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_APP_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetAppQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetAppQueryReturn<T>;
}

type UseGetAppLazyQueryReturn<T extends boolean> = LazyQueryResultTupleOverride<
  Record<'result', References.GetAppResponseType>,
  References.GetAppRequestType,
  T extends true
    ? Record<'getApp', References.GetAppResponseType>
    : References.GetAppResponseType
>;

export function useGetAppLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppResponseType>,
    References.GetAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppLazyQueryReturn<T>;
}

type UseGetAppSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAppResponseType>,
    References.GetAppRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getApp', References.GetAppResponseType>
    : References.GetAppResponseType;
};

export function useGetAppSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppResponseType>,
    References.GetAppRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_APP_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApp: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppSuspenseQueryReturn<T>;
}
